import Vue from "vue";
import Vuex from "vuex";
import API from "./Api";

Vue.use(Vuex);

let getDefaultState = () =>{
  return {
    user: {fullname: "", profiles: {}, avatar: ""},
    // stamps: {},
    statistics: {
      stamp:{
        total: 0
      }
    },
    userData: {},
    buyStampData: {},
    walletBalance: 0,
    stamps: [],
    vaultStamps: [],
    totalStamps: null,
    stampLogs: {},
    verificationLogs: {},
    topupData: {},
    tables: [],
    profiles:[],
    currentEntry: {},
    staticImage: "https://play.qubit.ng/v1/daemon/stamp/image/",
    rawURI: "https://play.qubit.ng/v1/",
    stampDesigns: {},
    walletTransactions: {},
    stampCategories: [],
    vaultOptions: [],
    modalType: "",
    vaultInfo: {},
    stampInfo: {},
    refreshTimeStamp: 0,
    idle: false,
    identicalStamps: [],
    avatar: '',
    hasPaginationInitialized: false
    // staticImage: "http://qubit.oleku.me:7080/v1/daemon/stamp/image/"
  };
};
export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState());
    },
    setWalletBalance(state, payload){
      state.walletBalance = payload/100;
    },
    setVaultStamps(state, payload){
      state.vaultStamps = payload;
    },
    setVaultInfo(state, payload){
      state.vaultInfo = payload;
    },
    setStampInfo(state, payload){
      state.stampInfo = payload;
    },
    setStampLogs(state, payload){
      state.stampLogs = payload.data;
      state.statistics.stamp.total = payload.info.total;
    },
    setVerificationLogs(state, payload){
      // console.log(payload);
      state.verificationLogs = payload.data;
      state.statistics.verification.total = payload.info.total;
    },
    setStampDesigns(state, payload){
      state.stampDesigns = payload;
      state.stamps = payload;
    },
    setWalletTransaction(state, payload){
      state.walletTransactions = payload;
    },
    logout(state){
      // localStorage.removeItem("last_url");
      console.log("store logout");
      localStorage.removeItem("passport");
      sessionStorage.removeItem("passport");
      localStorage.removeItem("userData");
      localStorage.removeItem("idle");
      localStorage.removeItem("mobileDesk");
    }
  },
  actions: {
    showLoading (context, ref) {
      let loader = this.$loading.show({
        container: ref
      });
      return loader;
    },
    async extractStampCategories(context) {
      var stampCategories = [{id: "", text: "all".toUpperCase()}];
      var stampCategoryTexts = [];
      await context.state.stamps.map(stamp => {
        if (stampCategoryTexts.indexOf(stamp.category) < 0) {
          stampCategories.push({id: stamp.category, text: stamp.category.toUpperCase()});
          stampCategoryTexts.push(stamp.category);
        }
      });
      return stampCategories;
    },
    async extractVaultCategories(context) {
      var stampCategories = [{id: "", text: "All".toUpperCase()}];
      var stampCategoryTexts = [];
      await context.state.identicalStamps.map(stamp => {
        // console.log("stamp", stamp);
        if (stampCategoryTexts.indexOf(stamp.category) < 0) {
          stampCategories.push({id: stamp.category, text: stamp.category.toUpperCase()});
          stampCategoryTexts.push(stamp.category);
        }
      });
      return stampCategories;
    },
    // wallet actions
    async getWalletBalance({commit}){
      let res = await API.get("wallet/balance");
      commit("setWalletBalance", res.info.balance);
    },

    async getWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/fetch?size=${size}&page=${page}`);
      commit("setWalletTransaction", res.data);
      return res;
    },

    async getPrimaryWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/summon/1?size=${size}&page=${page}`);
      return res;
    },

    async getAgentWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/summon/2?size=${size}&page=${page}`);
      return res;
    },

    async getSettlementWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/summon/4?size=${size}&page=${page}`);
      return res;
    },

    async getDemandWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/summon/8?size=${size}&page=${page}`);
      return res;
    },

    async getSalesWalletTransactions({commit}, page, size=20){
      let res = await API.get(`wallet/summon/16?size=${size}&page=${page}`);
      return res;
    },
    async getPaymentTransactions({commit}, page, size=20){
      let res = await API.get(`payment/fetch?size=${size}&page=${page}`);
      return res;
    },
    async concludePayment({commit}, reference){
      let res = await API.get("payment/paystack/conclude/" + reference);
      commit("setWalletBalance", res.info.balance);
      return res;
    },
    async startPayment({commit}, amount){
      let res = await API.post("payment/paystack/start", amount);
      return res;
    },
    async getBankList() {
      let res = await API.get('/payment/paystack/banks')
      return res;
    },
    async chargeBankAccount({commit}, data) {
      let res = await API.post('/payment/paystack/charge/account', data)
      return res;
    },
    async confirmBirthday({commit}, data) {
      let res = await API.post(`/payment/paystack/charge/condition/${data.plid}`, data.birthdayData);
      return res;
    },
    async sendAccountOtp({commit}, data) {
      let res = await API.post(`/payment/paystack/charge/condition/${data.plid}`, data.otpData)
      return res;
    },
    async getVault({commit}, size=400){
      let res = await API.get(`stamp/fetch/vault?size=${size}`);
      commit("setVaultStamps", res.data);
      commit("setVaultInfo", res.info);
      return res;
    },
    async getStampLog({commit}, size=400){
      let res = await API.get(`stamp/fetch/log?size=${size}`);
      commit("setStampLogs", res);
      return res;
    },
    async getVerificationLog({commit}, size=400){
      let res = await API.get(`verification/fetch/all?size=${size}`);
      commit("setVerificationLogs", res);
      return res;
    },
    async getDesigns({commit}){
      let res = await API.get("design/fetch");
      commit("setStampDesigns", res.data);
      return res.data;
    },
    async getTables({commit}, currentPage){
      let res = await API.get(`storage/table/fetch?page=${currentPage}&size=20`);
      return res;
    },
    async getEntries({commit}, tlid){
      let res = await API.get("storage/entry/" + tlid + "/fetch");
      return res;
    },
    async getCallbacks({commit}, tlid){
      let res = await API.get("integration/callback/fetch");
      return res;
    },
    async sendBulkStorageData({commit}, data){
      let stamp = data.stamp;
      delete data.stamp;
      let res = await API.post(`bulk/storage/${stamp}`, data);
      return res;
    },
    async sendBulkCallbackData({commit}, data){
      let stamp = data.stamp;
      delete data.stamp;
      let res = await API.post(`bulk/callback/${stamp}`, data);
      return res;
    },
    async sendBulkCsvData({commit}, data){
      let stamp = data.stamp;
      delete data.stamp;
      let res = await API.post(`bulk/data/${stamp}`, data);
      return res;
    },
    async getBulkHistory({commit}, pageNumber){
      let res = await API.get(`bulk/fetch?page=${pageNumber}&size=20`);
      return res;
    },
    async getCallbacksForTable({commit}, pageNumber){
      let res = await API.get(`integration/callback/fetch?page=${pageNumber}`);
      return res;
    },
    async getSerialDetails({commit}, serial){
      let res = await API.get(`stamp/info/${serial}`);
      return res;
    },
    async getDlidDetails({commit}, dlid){
      let res = await API.get(`design/info/${dlid}`);
      return res;
    },
    async getBulkStamps({commit}, blid, pageNumber){
      let res = await API.get(`bulk/fstamp/${blid}?page=${pageNumber}&size=20`);
      return res;
    },
    async refreshToken({commit}){
      let res = await API.get("https://play.qubit.ng/v1/core/auth/refresh");
      return res;
    },
    async setMyVault ({commit, state}, callback) {
      var identicalStamps = [];
      state.identicalStamps = [];
      state.vaultOptions = [{id: "", text: "Select a stamp"}] // clear options tag

      if (state.vaultStamps.length > 0) {
        await state.vaultStamps.map((stamp) => {
          state.stamps.map((iStamp, index2) => {
            if (stamp.dlid === iStamp.dlid) {
              /*
                get all the needed data in stamp vault that is not present
                in stamp gallery..
                Since we are using stamp gallery as the default data content
                for stamps based on its robustness
              */
              if (callback && typeof(callback) === "function") callback(index2);

              iStamp.used = stamp.used;
              iStamp.purchasedTotal = stamp.total;
              iStamp.index_ = index2;

              identicalStamps.push(iStamp);
              state.identicalStamps.push(iStamp);
              state.vaultOptions.push({id: index2, text: iStamp.title});
            }
          });
        });
      }
      else {
        console.log("alright, we would discuss other things later");
      }

      return identicalStamps;
    },
    async dlid2Index ({state}, dlid) {
      var index;
      await state.stamps.find((o, i) => {
        if (o.dlid === dlid) {
          index = i;
          return i;
        }
      });

      return index;
    },
    async getApisForTable({commit}, pageNumber){
      let res = await API.get(`integration/web/fetch?page=${pageNumber}&size=20`);
      return res;
    },
    async sendApiData({commit}, data){
      let res = await API.post(`integration/web/add`, data);
      return res;
    },
    async updateStampData ({state}, payload) {
      var vaultIndex = payload.vaultIndex;
      var data = payload.data;
      var keyArray = Object.keys(data);
      var result;
      keyArray.map((content) => {
        if (content === 'used') {
          console.log('used was called');
          state.stamps[vaultIndex][content] = state.stamps[vaultIndex][content] + data[content];
        } else {
          state.stamps[vaultIndex][content] = data[content];
        }
        result = state.stamps[vaultIndex];
      });
      return result;
    }
  }
});
